import axios from 'axios';
import AsyncStorage from '../src/services/storage';
import { signOut } from '../src/services/auth/Auth';
import { Platform } from '../src/web/react-native';
import DeviceInfo from '../src/services/deviceInfo';
import { correlationId, deviceId } from '../src/logging/ddUtils';
import { DdLogs } from '../src/logging/datadog';

export default {
  getShiftLogAssetName: (preferences) => {
    return (
      preferences?.post?.assetName ||
      preferences?.console?.assetName ||
      preferences?.selectedAsset?.assetName ||
      preferences?.assetName ||
      ''
    );
  },

  takeOverRequest: async (params, siteCode) => {
    let { shiftSummaryID } = params;
    // siteCode = 'TestSite';
    DdLogs.info('take over request......');
    return axios({
      method: 'get',
      url: `/shiftlogs/${siteCode}/takeoverDetails/${shiftSummaryID}`,
    }).then((res) => {
      DdLogs.info(`take over request... ${res.data}`);
      return res;
    });
  },

  /**********               Handles local storage               **********/
  setLatestUpdateTime: async (latestUpdateTime) => {
    await AsyncStorage.setItem('latestUpdateTime', latestUpdateTime);
  },
  getLatestUpdateTime: async () => {
    return await AsyncStorage.getItem('latestUpdateTime');
  },
  getLocalPreferences: async () => {
    return JSON.parse(await AsyncStorage.getItem('preferences'));
  },
  //save all sites info into AsyncStorage
  getSites: async () => {
    return JSON.parse(await AsyncStorage.getItem('sites'));
  },
  setSites: async (sites) => {
    await AsyncStorage.setItem('sites', JSON.stringify(sites));
  },

  logOut: async () => {
    await signOut();
  },

  sendFeedback: async ({ text, metadata, type }) => {
    const feedback = new Feedback({ text, metadata });
    try {
      const response = await axios.post(`emkit://feedback/${type}`, feedback);
      return (response.status + '')[0] === '2';
    } catch (e) {
      throw e;
    }
  },
};

const Feedback = ({ text, metadata }) => {
  return {
    text,
    metadata,
    appId: DeviceInfo.getBundleId(),
    appName: DeviceInfo.getApplicationName(),
    appVersion: DeviceInfo.getVersion(),
    appBuild: DeviceInfo.getBuildIdSync(),
    correlationId: correlationId,
    deviceInfo: `${DeviceInfo.getModel()} | ${Platform.OS} ${DeviceInfo.getSystemVersion()}`,
    deviceId: deviceId,
  };
};